import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { StyledButton } from "@insite/mobius/Clickable";
import Search from "@store/Components/Icons/Search";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(searchWithinStyles, {
    wrapper: {
        css: css`
            margin-bottom: 30px;
        `,
    },
    titleText: {
        forwardAs: "h3",
        weight: TYPOGRAPHY.weight.bold,
        color: "text.titles",
        size: TYPOGRAPHY.size.base,
        lineHeight: "inherit",
        css: css`
            display: block;
            padding: 0 0 15px;
            border: 0;
        `,
    },
    searchTextField: {
        border: null,
        iconProps: {
            src: Search,
            css: css`
                svg {
                    width: 16px;
                    height: 16px;
                }
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;

                ${StyledButton} {
                    span {
                        color: ${COLORS.secondary.dark};
                    }
                }
            `,
            inputSelect: css`
                font-size: ${TYPOGRAPHY.size.smaller};
                font-style: normal;
                border-width: 2px;
            `,
        },
    },
});
